import type { ReactElement } from 'react';
import { Group, Text } from '@mantine/core';
import { Sparkles } from 'lucide-react';
import { SurfaceCard } from '@/design/SurfaceCard';
import type { VizAccent } from '@/design/VizAccents';
import CalloutList from './CalloutList';
import type { TopicCallout } from './TopicNarration';

interface DerivedInsightsPanelProps {
    callouts: TopicCallout[];
    accent: VizAccent;
}

/**
 * The side-rail "Insights" card for screens whose data isn't a standard topic
 * aggregate (so the LLM-backed {@link TopicInsightsPanel} doesn't apply): renders
 * client-derived callouts under the same header. Returns null when there's
 * nothing to say.
 */
export default function DerivedInsightsPanel({ callouts, accent }: DerivedInsightsPanelProps): ReactElement | null {
    if (callouts.length === 0) return null;
    return (
        <SurfaceCard $padding="md">
            <Group gap={6} mb="sm" wrap="nowrap">
                <Sparkles size={14} style={{ color: 'var(--mantine-primary-color-filled)' }} />
                <Text size="xs" fw={700} tt="uppercase" c="dimmed" style={{ letterSpacing: '0.06em' }}>
                    Insights
                </Text>
            </Group>
            <CalloutList callouts={callouts} accent={accent} />
        </SurfaceCard>
    );
}
